import { useEffect, useState } from 'react';
import { Form, FormInstance } from 'antd';

export const useDynamicRequiredRules = (form?: FormInstance) => {
  const relatedFields = ['mobileNumber', 'email', 'phoneNumber'];

  const [isMobileRequired, setIsMobileRequired] = useState<boolean>(true);
  const [isEmailRequired, setIsEmailRequired] = useState<boolean>(true);

  Form.useWatch([], form);

  useEffect(() => {
    const values = form?.getFieldsValue(relatedFields) || {};
    const hasValue = Object.values(values).some((value) => value !== undefined && value !== '');
    const { mobileNumber, email, phoneNumber } = values;

    setIsMobileRequired(!email && !phoneNumber);
    setIsEmailRequired(!mobileNumber && !phoneNumber);

    if (hasValue) {
      form?.validateFields(relatedFields);
    }
  }, [form?.getFieldsValue(relatedFields)]);

  return { isMobileRequired, isEmailRequired };
};
